import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProofSection() {
  const outcomes = ['Esa presión constante en el pecho por el dinero disminuirá hasta desaparecer.', 'Empezarás a tomar decisiones de negocios desde la visión, no desde la necesidad (esto solo ya vale miles de dólares).', "Tu entorno notará algo diferente en tu energía. Atraerás a personas y oportunidades que antes estaban 'fuera de tu liga'.", 'Tendrás claridad absoluta sobre por qué fallaste en el pasado, quitándote el peso de la culpa de encima.'];
  return <section id="garantia" className="py-16 md:py-[80px] px-4 bg-[#050505] border-y border-border" data-id="element-277">
      <div className="max-w-[800px] mx-auto" data-id="element-278">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-279">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-gold uppercase" data-id="element-280">
            <span className="inline-block h-[2px] w-5 bg-gold" data-id="element-281"></span>
            Resultados
          </div>
          <h2 className="mb-4 font-heading text-3xl md:text-[40px] font-black leading-[1.1] text-white uppercase tracking-tight" data-id="element-282">
            ¿QUÉ SUCEDERÁ EN <span className="text-gold" data-id="element-283">TU VIDA?</span>
          </h2>
          <div className="whitespace-pre-wrap rounded-r-lg border border-border border-l-[3px] border-l-gold bg-surface-dark px-[22px] py-[20px] text-[14px] italic leading-[1.8] text-text-quote" data-id="element-284">
            "No te prometo que mañana despertarás con un millón de dólares en el
            banco. Eso sería mentirte y yo respeto tu proceso. Lo que sí te
            garantizo es que en los próximos 7 días:"
          </div>
        </motion.div>

        <motion.div className="overflow-hidden rounded-lg border border-border bg-surface mb-10" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-285">
          <div className="flex items-center gap-2 border-b border-border bg-surface-light px-[18px] py-3" data-id="element-286">
            <div className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-287"></div>
            <div className="font-heading text-[9px] font-bold tracking-[2px] text-gold uppercase" data-id="element-288">
              Los Próximos 7 Días
            </div>
          </div>
          <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-text-card" data-id="element-289">
            <ul className="flex flex-col" data-id="element-290">
              {outcomes.map((outcome, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-2 border-b border-border py-2.5 last:border-0 last:pb-0" data-id="element-291">
                  <span className="mt-[2px] shrink-0 font-bold text-gold" data-id="element-292">
                    →
                  </span>
                  <span className="text-white" data-id="element-293">{outcome}</span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center" data-id="element-294">
          <div className="inline-block rounded-lg border border-gold/30 bg-gold/5 px-6 py-4 text-[15px] font-bold italic text-gold" data-id="element-295">
            "Cuando el punto ciego se revela, el crecimiento deja de ser un
            esfuerzo y se convierte en una consecuencia."
          </div>
        </motion.div>
      </div>
    </section>;
}